import React, { useState, useEffect } from "react";

const links = [
  { id: "accueil", label: "ACCUEIL" },
  { id: "pagnes", label: "PAGNES" },
  { id: "programme", label: "PROGRAMME" },
  { id: "contact", label: "CONTACT" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "py-2 shadow-[0_8px_30px_-15px_rgba(0,0,0,0.5)]" : "py-3"
      }`}
      style={{
        background:
          "linear-gradient(180deg, rgba(8,46,33,0.96) 0%, rgba(10,61,46,0.93) 100%)",
        borderBottom: "1px solid rgba(201,169,97,0.35)",
      }}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between gap-4">
        {/* Logo Y&M */}
        <button
          onClick={() => scrollTo("accueil")}
          data-testid="nav-logo"
          className="flex items-center gap-3 group"
        >
          <span
            className="relative inline-flex items-center justify-center w-12 h-12 md:w-14 md:h-14"
            style={{
              border: "1.5px solid #C9A961",
              borderRadius: "50%",
              background:
                "radial-gradient(circle at 50% 30%, rgba(255,255,255,0.06), rgba(10,61,46,0))",
            }}
          >
            <span className="font-script text-2xl md:text-3xl shimmer-text">
              Y&amp;M
            </span>
            <span
              className="absolute -inset-1 rounded-full pointer-events-none"
              style={{ border: "1px solid rgba(201,169,97,0.35)" }}
            />
          </span>
        </button>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="text-[#E8D9A8] hover:text-[#F5E5B0] transition-colors text-[12px] tracking-[0.35em] font-medium"
            >
              {l.label}
            </button>
          ))}
        </nav>

        {/* RSVP button */}
        <button
          onClick={() => scrollTo("contact")}
          data-testid="nav-rsvp"
          className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 rounded-sm"
          style={{
            background:
              "linear-gradient(135deg, rgba(201,169,97,0.18), rgba(201,169,97,0.06))",
            border: "1px solid #C9A961",
            color: "#F5E5B0",
            letterSpacing: "0.3em",
            fontSize: "12px",
            fontWeight: 600,
          }}
        >
          RSVP <span className="text-[#F5E5B0]">♡</span>
        </button>

        {/* Mobile toggle */}
        <button
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-toggle"
          className="lg:hidden text-[#E8D9A8] p-2"
          aria-label="Menu"
        >
          <span className="block w-6 h-[1.5px] bg-[#E8D9A8] mb-1.5" />
          <span className="block w-6 h-[1.5px] bg-[#E8D9A8] mb-1.5" />
          <span className="block w-4 h-[1.5px] bg-[#E8D9A8] ml-auto" />
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div
          className="lg:hidden border-t border-[#C9A961]/30 px-6 py-4 space-y-3"
          style={{ background: "rgba(8,46,33,0.98)" }}
        >
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              data-testid={`nav-m-${l.id}`}
              className="block w-full text-left text-[#E8D9A8] tracking-[0.3em] text-xs py-2"
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo("contact")}
            className="w-full mt-2 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-sm"
            style={{
              background:
                "linear-gradient(135deg, rgba(201,169,97,0.25), rgba(201,169,97,0.1))",
              border: "1px solid #C9A961",
              color: "#F5E5B0",
              letterSpacing: "0.3em",
              fontSize: "12px",
              fontWeight: 600,
            }}
          >
            RSVP ♡
          </button>
        </div>
      )}
    </header>
  );
}
